import { Grid } from '@mui/material';
import { Field } from 'formik';
import React from 'react';
import HdFormikPasswordField from '../../../../../form/formik/components/password-field/HdFormikPasswordField';
import HdFormikTextField from '../../../../../form/formik/components/text-field/HdFormikTextField';
import HdFormControl from '../../../../../form/components/form-control/HdFormControl';

export default function Freshdesk({ isEditing }: { isEditing: boolean }) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='subdomain'
              required
              label='Subdomain'
              helperText='Specify your Freshdesk URL (https://subdomain.freshdesk.com)'
              prefixText='https://'
              suffixText='.freshdesk.com'
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='apiToken'
              required
              label='API Token'
              helperText={'Your personal Freshdesk API Key.'}
              masked={isEditing}
              component={HdFormikPasswordField}
            />
          </HdFormControl>
        </Grid>
      </Grid>
    </>
  );
}
